export function removeDragImage(event: DragEvent) {
    // Creates an empty image. See https://stackoverflow.com/questions/38655964/how-to-remove-dragghost-image
    const emptyImage = new Image();
    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

    event.dataTransfer!.setDragImage(emptyImage, 0, 0);
    event.dataTransfer!.effectAllowed = 'move';
}
